import { render, staticRenderFns } from "./RealisationSidebarEventsTab.vue?vue&type=template&id=65b32c59"
import script from "./RealisationSidebarEventsTab.vue?vue&type=script&lang=js"
export * from "./RealisationSidebarEventsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports